/**
 * Enumeration representing different rolling date filter operators.
 * @enum {string}
 */
export enum RollingDateFilterOperators {
    YESTERDAY = 'YESTERDAY',
    TODAY = 'TODAY',
    TOMORROW = 'TOMORROW',
    THIS = 'THIS',
    LAST = 'LAST',
    NEXT = 'NEXT',
    BEFORE = 'BEFORE',
    AFTER = 'AFTER',
    ON_OR_BEFORE = 'ON_OR_BEFORE',
    ON_OR_AFTER = 'ON_OR_AFTER',
    WEEK_TO_DATE = 'WEEK_TO_DATE',
    MONTH_TO_DATE = 'MONTH_TO_DATE',
    QUARTER_TO_DATE = 'QUARTER_TO_DATE',
    YEAR_TO_DATE = 'YEAR_TO_DATE',
}

/**
 * Enumeration representing the list of dropdown option labels for rolling date filter operator dropdown.
 * @enum {string}
 */
export enum RollingDateFilterOperatorLabels {
    YESTERDAY = 'dateFilter.yesterday',
    TODAY = 'dateFilter.today',
    TOMORROW = 'dateFilter.tomorrow',
    THIS = 'dateFilter.this',
    LAST = 'dateFilter.last',
    NEXT = 'dateFilter.next',
    BEFORE = 'dateFilter.is_before',
    AFTER = 'dateFilter.is_after',
    ON_OR_BEFORE = 'dateFilter.is_on_or_before',
    ON_OR_AFTER = 'dateFilter.is_on_or_after',
    WEEK_TO_DATE = 'dateFilter.week_to_date',
    MONTH_TO_DATE = 'dateFilter.month_to_date',
    QUARTER_TO_DATE = 'dateFilter.quarter_to_date',
    YEAR_TO_DATE = 'dateFilter.year_to_date',
}
